<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-4">
                <div class="form-group input-group-sm">
                    <button class="btn btn-success btn-sm mr-2 mb-4 mt-4 torre-btn" @click="addNewItem">Nowa grupa produktów</button>
                    <br/>
                    <label>Grupy produktów</label>
                    <select class="form-control select-size" v-model="selectedGroupedProduct">
                        <option v-for="gp in groupedProducts" :key="gp.id" v-bind:value="gp" >
                        {{ groupItemLabel(gp) }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4" v-if="properGroupProduct">
                <vue-tags-input
                    placeholder="Dodaj produkt"
                    :autocomplete-items="autocompleteItems"
                    :add-only-from-autocomplete="true"
                    v-model="element"
                    :tags="elements"
                    @tags-changed="elementsChanges"
                />
            </div>
        </div>
    </div>
</template>
<script>
import VueTagsInput from '@johmun/vue-tags-input';
import restClient from "./GroupProductRestClient"
import un from 'underscore'

export default {
    components: {
        VueTagsInput,
    },
    data() {
        return {
            element: '',
            productNames: [],
            selectedGroupedProduct: {},
            newGroupedProduct: {},
            groupedProducts: []
        }
    },
    created() {
        restClient.all()
        .then(res => {
            this.initGroupedProducts(res.data)
        })
        restClient.getAllProductNames()
        .then(res => {
            this.productNames = res.data
        })
    },
    computed: {
        mode() {
            if (this.selectedGroupedProduct.id)
                return "edit"
            if (this.newGroupedProduct.elements)
                return "add"
            return "none"
        },
        properGroupProduct() {
            return this.mode !== "none"
        },
        elements() {
            const arr = this.selectedGroupedProduct.elements || []
            return un.map(arr, (item) => {
                return {
                    text: item,
                    style: "background-color: #97b84d;"
                }
            })
        },
        availableItems() {
            const selectedGroupedProductAvailableItems =  un.difference(
                this.productNames,
                this.selectedGroupedProduct.elements || []
            )
            const items = un.map(this.groupedProducts, item => item.elements)
            const flattenGroupedProducts = un.flatten(un.map(items, un.values))
            return un.difference(
                selectedGroupedProductAvailableItems,
                flattenGroupedProducts
            )
        },
        autocompleteItems() {
            return un.chain(this.availableItems)
                .filter((item) => {
                    return item.toLowerCase().indexOf(this.element.toLowerCase()) !== -1;
                })
                .map((item) => {
                return {
                    text: item
                }
            }).value()
        }
    },
    methods: {
        addNewItem() {
            this.selectedGroupedProduct = {}
            this.newGroupedProduct.elements = []
        },
        elementsChanges(actualElements) {
            if (this.mode == "edit")
                this.updateSelectedGroupedProduct(actualElements)
            if (this.mode == "add")
                this.addSelectedGroupedProduct(actualElements)
        },
        addSelectedGroupedProduct(actualElements) {
            this.selectedGroupedProduct.elements = un.map(actualElements, item => item.text)
            restClient.add(this.selectedGroupedProduct)
            .then(res => {
                this.selectedGroupedProduct.id = res.data.id
                this.newGroupedProduct = {}
                this.groupedProducts.push(this.selectedGroupedProduct)
            })
        },
        updateSelectedGroupedProduct(actualElements) {
            if (actualElements.length == 0) {
                restClient.delete(this.selectedGroupedProduct)
                .then(res => {
                    const itemToRemove = un.findWhere(this.groupedProducts, { id: this.selectedGroupedProduct.id })
                    this.groupedProducts = un.without(this.groupedProducts, itemToRemove)
                })
                return
            }
            this.selectedGroupedProduct.elements = un.map(actualElements, item => item.text)
            restClient.edit(this.selectedGroupedProduct)
            .then(_ => {})
        },
        groupItemLabel(groupedProduct) {
            const maxLetters = 70
            const label = groupedProduct.elements.join()
            return label.length > maxLetters ? label.slice(0, maxLetters) + "..." : label
        },
        initGroupedProducts(data) {
            this.groupedProducts = data
        }
    }
}
</script>
<style lang="scss" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/group-product/GroupProduct.vue